export default "__VITE_ASSET__ded6d778__"